import { Flex, useDisclosure, Text } from '@chakra-ui/react';
import { RModal, RTooltip } from 'components';
import { PrizePoolStrategy } from 'components/PrizePool/PrizePool';
import { IconInfo, IconTrophyFilled } from 'icons';

export const RacePrizePool = ({
  raceId,
  prizePool,
  fontSize,
  fractionDigits,
  showText = false
}: {
  raceId: string;
  prizePool: number;
  fontSize?: string | Record<string, string>;
  fractionDigits?: number;
  showText?: boolean;
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <RTooltip label="View details">
        <Flex
          h="100%"
          justify="center"
          align="center"
          cursor="pointer"
          flexDir="column"
          onClick={(e) => {
            e.stopPropagation();
            console.log('clicked');
            onOpen();
          }}
        >
          <Flex
            alignItems="center"
          >
            <Text color="treasuredTeal.100" fontSize={fontSize || 'lg'} fontWeight="semibold" lineHeight={fontSize || 'inherit'}>
              {new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: fractionDigits || 0,
                maximumFractionDigits: fractionDigits || 0,
              }).format(Number(prizePool) / 100)}
            </Text>
            <IconInfo
              __css={{
                path: { fill: 'treasuredTeal.100' },
                ml: 1,
                width: '20px',
              }}
            />
          </Flex>
          {showText && (
            <Text
              fontSize="10px"
              lineHeight="12px"
              fontWeight="600"
              color="cerebralGrey.100"
            >
              PRIZEPOOL
            </Text>
          )}
        </Flex>

      </RTooltip>

      <RModal
        size="2xl"
        title="PRIZEPOOL"
        isOpen={isOpen}
        onClose={onClose}
        isCentered
        icon={
          <IconTrophyFilled 
            __css={{
              path: { fill: 'rgba(79, 197, 186, 1)'}
            }}
            width={{ base: '1.125rem', md: '2rem' }}
            height="auto"
          />
        }
      >
        <PrizePoolStrategy raceId={raceId} />
      </RModal>
    </>
  );
};
